import { useEffect, useState } from "react";

/**
 * Premium 4-block countdown — days/hours/minutes/seconds with
 * tabular monospace and a soft pulse on the seconds digit so the
 * timer reads as "alive."
 */
export function Countdown({ endsAt }: { endsAt: bigint | number }) {
  const target = typeof endsAt === "bigint" ? Number(endsAt) : endsAt;
  const [now, setNow] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    const id = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => clearInterval(id);
  }, []);

  const remaining = Math.max(0, target - now);
  const d = Math.floor(remaining / 86400);
  const h = Math.floor((remaining % 86400) / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = remaining % 60;

  return (
    <div className="flex items-center gap-2 font-mono">
      <Block label="DAYS" value={d} />
      <Sep />
      <Block label="HRS" value={h} />
      <Sep />
      <Block label="MIN" value={m} />
      <Sep />
      <Block label="SEC" value={s} pulse />
    </div>
  );
}

function Block({ label, value, pulse }: { label: string; value: number; pulse?: boolean }) {
  return (
    <div className="flex flex-col items-center">
      <div
        className={`min-w-[2.4rem] rounded-md border border-white/10 bg-black/40 px-2 py-1 text-center text-base font-semibold tabular-nums text-white ${
          pulse ? "shadow-[0_0_12px_-2px_rgba(192,132,252,0.5)]" : ""
        }`}
      >
        {String(value).padStart(2, "0")}
      </div>
      <div className="mt-0.5 text-[9px] uppercase tracking-widest text-white/40">{label}</div>
    </div>
  );
}

function Sep() {
  return <div className="text-white/30">:</div>;
}
